import { apiRequest } from 'src/api';

export const startBackgroundCheck = async ({
  accountId,
  financialInstitutionId,
  personId,
  packageCode,
  productCodes,
}) => {
  const url = accountId
    ? `/api/v1/accounts/${accountId}/users/${personId}/background_check/`
    : `/api/v1/fis/${financialInstitutionId}/users/${personId}/background_check/`;

  const data = {
    package: packageCode,
    products: productCodes,
  };

  return apiRequest({
    url,
    method: 'POST',
    data,
    responseDataAdapter: () => ({}),
  });
};

const backgroundCheckDataAdapter = response => ({
  personId: response.id_person,
  firstName: response.first_name,
  lastName: response.last_name,
  middleName: response.middle_name,
  suffix: response.suffix,
  ssn: response.ssn,
  dateOfBirth: response.date_of_birth,
  email: response.email,
  phone: response.phone,

  address: response.address,
  city: response.city,
  region: response.region,
  postalCode: response.postal_code,
  country: response.country,

  jobLocationCity: response.job_location_city,
  jobLocationCountry: response.job_location_country,

  backgroundCheckStatus: response.background_check_status,
  checkCompletedDate: response.check_completed_date,
  checkStartedDate: response.check_started_date,
  isCheckCompleted: response.is_check_completed,
  isCheckRunning: response.is_check_running,
});

export const getBackgroundCheckResult = async ({
  accountId,
  financialInstitutionId,
  personId,
}) => {
  const url = accountId
    ? `/api/v1/accounts/${accountId}/users/${personId}/background_check/`
    : `/api/v1/fis/${financialInstitutionId}/users/${personId}/background_check/`;

  return apiRequest({
    url,
    method: 'GET',
    FresponseDataAdapter: backgroundCheckDataAdapter,
  });
};

export const signBackgroundCheckConsent = async ({
  financialInstitutionId,
  initials,
  firstName,
  middleName,
  lastName,
  dob,
  primaryNumber,
  socialSecurity,
  citizenship,
  primaryAddress,
  primaryCity,
  primaryState,
  primaryZipcode,
}) => {
  return apiRequest({
    url: `/api/v1/fis/${financialInstitutionId}/background_check_consent/`,
    method: 'POST',
    data: {
      initials,
      person_first_name: firstName,
      person_middle_name: middleName,
      person_last_name: lastName,
      person_dob: dob,
      person_primary_number: primaryNumber,
      person_social_security: socialSecurity,
      person_citizenship: citizenship,
      person_primary_address: primaryAddress,
      person_primary_city: primaryCity,
      person_primary_state: primaryState,
      person_primary_zipcode: primaryZipcode,
    },
  });
};
